import { SortDirection } from "./enumerators";

interface CargoColumns<T> {
  [key: string]: Array<CargoItem<T>>;
}

interface CargoItem<T> {
  name: string;
  value: string | number | boolean;
  sortFunc?: (columnKey: keyof T, sortDirection: SortDirection, columnSubKey: string) => void;
  type: OmniusCargoColumnType;
}

enum OmniusCargoColumnType {
  string = "string",
  int = "int",
  bool = "bool",
  decimal = "decimal",
  dateTime = "dateTime",
}

export { CargoColumns, CargoItem, OmniusCargoColumnType };
